import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './NamechangeA.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../../utils/useLocalStorage";
import CorporateActOption from "../../CorporateActOption/CorporateActOption";
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function NamechangeA() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [DateLast, setDateLast] = useState(new Date().getFullYear());
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {

        const getUrl = BaseURL + "NameChange";
        fetch(`${getUrl}/-/${DateLast}`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                //console.log(getData, "getData")
            })
            .catch((error) => {
            });


    }, [DateLast]);

    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    
    CallTrackApi("Change Name",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Change of Name</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='namechng-loser-sc'>
                            <div className='namechng-header'>
                                <h2><span>Name Change</span></h2>
                            </div>
                            <CorporateActOption optionCorp="Change of Name" />
                            {/* <hr className="namechnghr"></hr> */}
                            <div className='namechng-right'>
                                <div className='namechng-inner-select'>
                                    
                                    {/* aria-label="Select Year" */}
                                    <select aria-label="Select Year" onChange={(event) => { setDateLast(event.target.value) }}>
                                        <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                                        <option value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</option>
                                        <option value={new Date().getFullYear() - 2}>{new Date().getFullYear() - 2}</option>
                                        <option value={new Date().getFullYear() - 3}>{new Date().getFullYear() - 3}</option>
                                        <option value={new Date().getFullYear() - 4}>{new Date().getFullYear() - 4}</option>
                                        <option value={new Date().getFullYear() - 5}>{new Date().getFullYear() - 5}</option>
                                        <option value={new Date().getFullYear() - 6}>{new Date().getFullYear() - 6}</option>
                                        <option value={new Date().getFullYear() - 7}>{new Date().getFullYear() - 7}</option>
                                        <option value={new Date().getFullYear() - 8}>{new Date().getFullYear() - 8}</option>
                                        <option value={new Date().getFullYear() - 9}>{new Date().getFullYear() - 9}</option>
                                        <option value={new Date().getFullYear() - 10}>{new Date().getFullYear() - 10}</option>
                                    </select>
                                </div>
                            </div>
                            <div className='namechng-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left' >New Name</th>
                                            <th className='chngtxt' >Old Name</th>
                                            <th className='text-center'>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ OLDNAME, NEWNAME, SRDT, CO_CODE }) => (
                                                <tr>
                                                    <td className="text-left"> <h6 onClick={routeChange} data-id={NEWNAME + '-' + CO_CODE}>{NEWNAME}</h6></td>
                                                    <td className="text-left"> {OLDNAME}</td>
                                                    <td className="text-center"> {(SRDT != null) ? SRDT.split('T')[0] : 0}</td>




                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default NamechangeA;